import { PerkCardMiniTemplate, PerkCardMiniTemplateProps } from "./template";

export type PerkCardMiniProps = PerkCardMiniTemplateProps;

export const PerkCardMini = (props: PerkCardMiniProps): JSX.Element => {
  return <PerkCardMiniTemplate {...props} />;
};
